var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"srcset":((_vm.$store.state.appUrl) + "/img/pwa/login/1.svg, " + (_vm.$store.state.appUrl) + "/img/pwa/login/1.svg"),"src":((_vm.$store.state.appUrl) + "/img/pwa/login/1.svg"),"alt":"Thrive"}})}
var staticRenderFns = []

export { render, staticRenderFns }